<div>
  <ng-template #participantStatusHeader>
    <div class="flex items-center gap-1">
      <span>{{
        'portal.trainings.enrolledStudentTable.headers.participantStatus'
          | transloco
      }}</span>
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help text-grey-midGrey"
        [matTooltip]="
          'portal.trainings.enrolledStudentTable.participantStatusTooltip'
            | transloco
        "
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
        >help_outline</mat-icon
      >
    </div>
  </ng-template>

  <ng-template #currentPhaseHeader>
    <div class="flex items-center gap-1">
      <span>{{
        (hasDeadline
          ? 'portal.trainings.enrolledStudentTable.headers.courseName'
          : 'portal.trainings.enrolledStudentTable.headers.currentPhase'
        ) | transloco
      }}</span>
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help text-grey-midGrey"
        [matTooltip]="
          (hasDeadline
            ? 'portal.trainings.enrolledStudentTable.courseNameTooltip'
            : 'portal.trainings.enrolledStudentTable.currentPhaseTooltip'
          ) | transloco
        "
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
        >help_outline</mat-icon
      >
    </div>
  </ng-template>

  <ng-template #progressHeader>
    <div class="flex items-center gap-1">
      <span>{{
        'portal.trainings.enrolledStudentTable.headers.status' | transloco
      }}</span>
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help text-grey-midGrey"
        [matTooltip]="
          'portal.trainings.enrolledStudentTable.progressTooltip' | transloco
        "
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
        >help_outline</mat-icon
      >
    </div>
  </ng-template>

  <ng-template #studentCard let-element>
    <div class="my-4">
      <app-user-card
        [username]="element.username"
        [email]="element.email"
        [syncStatus]="element.syncStatus"
        [highlightUsername]="false"
        [isCurrentUser]="isCurrentUser(element)"
        [useNewAvatarStyle]="true"
      />
    </div>
  </ng-template>

  <ng-template #participantStatus let-element>
    <div class="text-sm text-gray-700">
      {{
        'portal.trainings.enrolledStudentTable.participantStatus.' +
          (element.participantStatus || 'inactive') | transloco
      }}
    </div>
  </ng-template>

  <ng-template #progress let-element>
    <div class="flex items-center gap-1">
      <span
        [class]="
          'inline-flex items-center text-sm ' +
          getStatusColorClass(element.status) +
          ' rounded-2xl px-3 py-1'
        "
      >
        <mat-icon class="translate-y-0.5 text-xl leading-none">{{
          getStatusIcon(element.status)
        }}</mat-icon
        >{{
          'portal.courses.analytics.courseProgress.' + element.status
            | transloco
        }}
      </span>
    </div>
  </ng-template>

  <ng-template #phaseWithCourse let-element>
    <div class="flex flex-col">
      @if (!hasDeadline) {
        <span class="text-grey-dark text-sm font-normal leading-5">{{
          element.currentPhase
        }}</span>
      }
      @if (element.courseName) {
        <span
          [class]="
            hasDeadline
              ? 'text-grey-dark text-sm font-normal leading-5'
              : 'text-sm text-gray-600'
          "
        >
          {{
            'portal.courses.courseTitleKeys.' + element.courseName + '.name'
              | transloco
          }}
        </span>
      }
    </div>
  </ng-template>
</div>

<app-sep-table
  *transloco="let t"
  [columns]="columns"
  [dataSource]="dataSource"
  [rowActions]="
    canManageEnrollment() || isCertificateExportEnabled ? rowActions : []
  "
  [bulkActions]="bulkActions"
  [bulkActionsNote]="bulkActionsNote"
  [filterCategories]="filterCategories"
  [hasBulkActionButton]="canManageEnrollment() || isCertificateExportEnabled"
  [hasCheckbox]="canManageEnrollment() || isCertificateExportEnabled"
  [name]="t('portal.courses.enrollment.participantsHeadline')"
  [noDataText]="t('portal.courses.enrollment.noDataTableText')"
  [checkboxSelectedText]="t('portal.courses.enrollment.checkboxSelectedText')"
  [primaryButtonTitle]="t('portal.courses.enrollment.addParticipantsHeadline')"
  (primaryButtonClickedEvent)="showCourseEnrollmentDialog()"
  [allowExport]="true"
  [toolbarExportActions]="toolbarExportActions"
  [hidePrimaryButton]="!allowEnrollment"
  [primaryButtonDisabled]="isEnrollmentBlockedByDeadline"
  [primaryButtonDisabledTooltip]="
    t('portal.courses.enrollment.addParticipantsDisabledTooltip')
  "
  [loading]="isLoadingStudents()"
  (exportContentButtonClickedEvent)="exportTableContentsToCsv()"
>
  <ng-template #toolbarLeft>
    @if (periodPickerControl && !hasDeadline) {
      <app-select
        [control]="periodPickerControl"
        [options]="periodPickerOptions"
        [bottomMargin]="false"
        [icon]="'calendar_today'"
        class="min-w-[180px]"
      />
    }
  </ng-template>
</app-sep-table>
